import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53375)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.6672 41.3788H0.862598C0.386524 41.3788 0.000488281 40.9928 0.000488281 40.5167V9.48223C0.000488281 9.00615 0.386524 8.62012 0.862598 8.62012H16.6672V41.3788Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.3345 8.62061H16.6675V41.3794H33.3345V8.62061Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1381 41.3787H33.3335V8.62012H49.1381C49.6142 8.62012 50.0002 9.00615 50.0002 9.48223V40.5167C50.0002 40.9929 49.6142 41.3787 49.1381 41.3787Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53375",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFrFlag);
export { ForwardRef as ReactComponent };
